import {QType, Rtype, TimeScale, Utype, Vtype} from "./global";
import DF from "./DateFormat";

export const QuickSub = (phrase,obj) => { // 1.值变化触发警告如何配置？ 2.订阅电压、电流等量
  let opt = undefined;
  switch (phrase){
    case "Sgl_[P]_Value" :
      opt = StateV({id:obj.uType === Utype.GATEWAY? 'ambient-' + obj.id : obj.id,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId})
      break;
    case "Tri_[P]_Value":
      opt = [
        StateV({id:obj.uType === Utype.GATEWAY? 'ambient-' + obj.id : obj.id,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:"PA"}),
        StateV({id:obj.uType === Utype.GATEWAY? 'ambient-' + obj.id : obj.id,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:"PB"}),
        StateV({id:obj.uType === Utype.GATEWAY? 'ambient-' + obj.id : obj.id,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:"PC"})
      ]
      break;
  }
  return opt;
}

export const QuickStart = (phrase,obj) => {
  let opt = undefined;
  switch (phrase){
    case "Sgl_[P]_Value": opt = CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId}); break;//单相【有功功率】状态值
    case "Sgl_[U]_Value": opt = CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U}); break;//单相【电压】状态值
    case "Sgl_[I]_Value": opt = CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I});break;//单相【电流】状态值
    case "Sgl_[nodeState]_Value": opt = [
      CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId}),
      CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U}),
      CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I})
    ];break;//单相【(P/U/I)】状态值
    case "Sgl_[Q]_Value": break;//单相【无功功率】状态值
    case "Sgl_[PF]_Value": opt = CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.Factor}); break;//单相【功率因素】状态值
    case "Sgl_[F]_Value": break;//单相【频率】状态值
    case "Sgl_[E_(H_)]_Value": opt = EnergyV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Hour,DateRange: DF.dateRange("H", "dt").join("~")});break; //单相【时电量】状态值
    case "Sgl_[E_(d_)]_Value": opt = EnergyV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Day,DateRange: DF.dateRange("nextd", "dt").join("~")});break;//单相【日电量】状态值
    case "Sgl_[E_(w_)]_Value": opt = EnergyV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Week,DateRange: DF.dateRange("nextw", "dt").join("~")});break;//单相【周电量】状态值
    case "Sgl_[E_(M_)]_Value": opt = EnergyV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Month,DateRange: DF.dateRange("nextM", "dt").join("~")});break;//单相【月电量】状态值
    case "Sgl_[E_(y_)]_Value": opt = EnergyV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Year,DateRange: DF.dateRange("nexty", "dt").join("~")});break;//单相【年电量】状态值
    case "Sgl_[Ctrl]_Value": opt = CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.Control,Rtype:Rtype.ToJson});break;
    case "Sgl_[Conn]_Value": opt = CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.Conn,Rtype:Rtype.ToJson});break;
    case "Sgl_[Switch]_Value": opt = CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.SwitchState});break;
    case "Sgl_[Temperature]_Value": opt = CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.T});break; //温度
    case "Sgl_[Humi]_Value": opt = CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.HUMI});break; //湿度
    case "Sgl_[Illum]_Value": opt = CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.ILLUM});break; //光照强度
    case "Sgl_[Environment]_Value": opt = [
      CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.T}),
      CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.HUMI}),
      CurveV({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.ILLUM})
    ];break; //环境参数

    case "Sgl_[P_(h_s)]_HisCurve": opt = CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      DateRange: DF.dateRange("H", "dt").join("~")});break;//单相【时内_有功功率】历史曲线
    case "Sgl_[U_(h_s)]_HisCurve": opt = CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      Vtype:Vtype.U,DateRange: DF.dateRange("H", "dt").join("~")});break;//单相【时内_电压】历史曲线
    case "Sgl_[I_(h_s)]_HisCurve": opt = CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      Vtype:Vtype.I,DateRange: DF.dateRange("H", "dt").join("~")});break;//单相【时内_电流】历史曲线
    case "Sgl_[Q_(h_s)]_HisCurve": break;//单相【时内_无功功率】历史曲线
    case "Sgl_[PF_(h_s)]_HisCurve": break;//单相【时内_功率因素】历史曲线
    case "Sgl_[F_(h_s)]_HisCurve": break;//单相【时内_频率】历史曲线
    case "Sgl_[P_(d_s)]_HisCurve": opt = CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId});break;//单相【日内_有功功率】历史曲线
    case "Sgl_[U_(d_s)]_HisCurve": opt = CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U});break;//单相【日内_电压】历史曲线
    case "Sgl_[I_(d_s)]_HisCurve": opt = CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I});break;//单相【日内_电流】历史曲线
    case "Sgl_[Q_(d_s)]_HisCurve": break; //单相【日内_无功功率】历史曲线
    case "Sgl_[PF_(d_s)]_HisCurve": break; //单相【时内_有功功率】历史曲线
    case "Sgl_[F_(d_s)]_HisCurve": break; //单相【日内_频率】历史曲线
    case "Sgl_[E_(d_H)]_HisCurve": opt = EnergyList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Hour,DateRange: DF.accCorrect(DF.dateRange("d"), "H", "dt").join("~")});break;//单相【日电量(小时级)】历史曲线
    case "Sgl_[E_(w_d)]_HisCurve": opt = EnergyList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Day,DateRange: DF.accCorrect(DF.dateRange("w"), "d", "dt").join("~")});break;//单相【周电量(日级)】历史曲线
    case "Sgl_[E_(M_d)]_HisCurve": opt = EnergyList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Day,DateRange: DF.accCorrect(DF.dateRange("M"), "d", "dt").join("~")});break;//单相【月电量(日级)】历史曲线
    case "Sgl_[E_(y_w)]_HisCurve": opt = EnergyList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Week,DateRange: DF.accCorrect(DF.dateRange("y"), "W", "dt").join("~")});break;//单相【年电量(周级)】历史曲线
    case "Sgl_[E_(y_M)]_HisCurve": opt = EnergyList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Month,DateRange: DF.accCorrect(DF.dateRange("y"), "M", "dt").join("~")});break;//单相【年电量(月级)】历史曲线
    case "Sgl_[Ctrl]_HisCurve": opt = CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.Control,Rtype:Rtype.ToAssignList});break;
    case "Sgl_[Conn]_HisCurve": opt = CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.Conn,Rtype:Rtype.ToAssignList});break;
    case "Sgl_[Switch]_HisCurve": opt = CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.SwitchState});break;
    case "Sgl_[Temperature]_HisCurve": opt = CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.T});break;
    case "Sgl_[Humi]_HisCurve": opt = CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.HUMI});break;
    case "Sgl_[Illum]_HisCurve": opt = CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.ILLUM});break;
    case "Sgl_[Environment]_HisCurve": opt = [
      CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.T}),
      CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.HUMI}),
      CurveList({id:phrase,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.ILLUM})
    ];break;

    case "Sgl_[P]_ForeValue":break;//单相【有功功率】预测值
    case "Sgl_[U]_ForeValue":break;//单相【电压】预测值
    case "Sgl_[I]_ForeValue":break;//单相【电流】预测值
    case "Sgl_[nodeState]_ForeValue":break;//单相【(P/U/I)】预测值
    case "Sgl_[Q]_ForeValue":break;//单相【无功功率】预测值
    case "Sgl_[PF]_ForeValue":break;//单相【功率因素】预测值
    case "Sgl_[F]_ForeValue":break;//单相【频率】预测值
    case "Sgl_[E_(H_)]_ForeValue":break;//单相【时电量】预测值
    case "Sgl_[E_(d_)]_ForeValue":break;//单相【日电量】预测值
    case "Sgl_[E_(w_)]_ForeValue":break;//单相【周电量】预测值
    case "Sgl_[E_(M_)]_ForeValue":break;//单相【月电量】预测值
    case "Sgl_[E_(y_)]_ForeValue":break;//单相【年电量】预测值

    case "Sgl_[P_(h_s)]_ForeCurve":break;//单相【时内_有功功率】预测曲线
    case "Sgl_[U_(h_s)]_ForeCurve":break;//单相【时内_电压】预测曲线
    case "Sgl_[I_(h_s)]_ForeCurve":break;//单相【时内_电流】预测曲线
    case "Sgl_[Q_(h_s)]_ForeCurve":break;//单相【时内_无功功率】预测曲线
    case "Sgl_[PF_(h_s)]_ForeCurve":break;//单相【时内_功率因素】预测曲线
    case "Sgl_[F_(h_s)]_ForeCurve":break;//单相【时内_频率】预测曲线
    case "Sgl_[P_(d_s)]_ForeCurve":break;//单相【日内_有功功率】预测曲线
    case "Sgl_[U_(d_s)]_ForeCurve":break;//单相【日内_电压】预测曲线
    case "Sgl_[I_(d_s)]_ForeCurve":break;//单相【日内_电流】预测曲线
    case "Sgl_[Q_(d_s)]_ForeCurve":break;//单相【日内_无功功率】预测曲线
    case "Sgl_[PF_(d_s)]_ForeCurve":break;//单相【日内_功率因素】预测曲线
    case "Sgl_[F_(d_s)]_ForeCurve":break;//单相【日内_频率】预测曲线
    case "Sgl_[E_(d_H)]_ForeCurve":break;//单相【日电量(小时级)】预测曲线
    case "Sgl_[E_(w_d)]_ForeCurve":break;//单相【周电量(日级)】预测曲线
    case "Sgl_[E_(M_d)]_ForeCurve":break;//单相【月电量(日级)】预测曲线
    case "Sgl_[E_(y_w)]_ForeCurve":break;//单相【年电量(周级)】预测曲线
    case "Sgl_[E_(y_M)]_ForeCurve":break;//单相【年电量(月级)】预测曲线

    case "Tri_[P]_Value": opt = TriPhaseV({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.P});break;//三相【有功功率】状态值
    case "Tri_[U]_Value": opt = TriPhaseV({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U});break;//三相【电压】状态值
    case "Tri_[I]_Value": opt = TriPhaseV({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I});break;//三相【电流】状态值
    case "Tri_[nodeState]_Value": opt = [
      TriPhaseV({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.P}),
      TriPhaseV({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U}),
      TriPhaseV({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I})
    ];break;//三相【(P/U/I)】状态值
    case "Tri_[Q]_Value":break;//三相【无功功率】状态值
    case "Tri_[PF]_Value": opt = TriPhaseV({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.PF});break;//三相【功率因素】状态值
    case "Tri_[F]_Value":break;//三相【频率】状态值
    case "Tri_[E_(H_)]_Value":break;//三相【时电量】状态值
    case "Tri_[E_(d_)]_Value":break;//三相【日电量】状态值
    case "Tri_[E_(w_)]_Value":break;//三相【周电量】状态值
    case "Tri_[E_(M_)]_Value":break;//三相【月电量】状态值
    case "Tri_[E_(y_)]_Value":break;//三相【年电量】状态值

    case "Tri_[P_(h_s)]_HisCurve": opt = TriCurveList({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.P,
        DateRange:DF.dateRange("H", "dt").join("~")});break;//三相【时内_有功功率】历史曲线
    case "Tri_[U_(h_s)]_HisCurve": opt = TriCurveList({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U,
      DateRange:DF.dateRange("H", "dt").join("~")});break;//三相【时内_电压】历史曲线
    case "Tri_[I_(h_s)]_HisCurve": opt = TriCurveList({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I,
      DateRange:DF.dateRange("H", "dt").join("~")});break;//三相【时内_电流】历史曲线
    case "Tri_[Q_(h_s)]_HisCurve":break;//三相【时内_无功功率】历史曲线
    case "Tri_[PF_(h_s)]_HisCurve":break;//三相【时内_功率因素】历史曲线
    case "Tri_[F_(h_s)]_HisCurve":break;//三相【时内_频率】历史曲线
    case "Tri_[P_(d_s)]_HisCurve": opt = TriCurveList({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.P});break;//三相【日内_有功功率】历史曲线
    case "Tri_[U_(d_s)]_HisCurve": opt = TriCurveList({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U});break;//三相【日内_电压】历史曲线
    case "Tri_[I_(d_s)]_HisCurve": opt = TriCurveList({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I});break;//三相【日内_电流】历史曲线
    case "Tri_[Q_(d_s)]_HisCurve":break;//三相【日内_无功功率】历史曲线
    case "Tri_[PF_(d_s)]_HisCurve":break;//三相【时内_有功功率】历史曲线
    case "Tri_[F_(d_s)]_HisCurve":break;//三相【日内_频率】历史曲线
    case "Tri_[E_(d_H)]_HisCurve": opt = TriEnergyList({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.E,
      TimeScale:TimeScale.Hour,DateRange: DF.accCorrect(DF.dateRange("d"), "H", "dt").join("~")}); break;//三相【日电量(小时级)】历史曲线
    case "Tri_[E_(w_d)]_HisCurve": opt = TriEnergyList({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.E,
      TimeScale:TimeScale.Day,DateRange: DF.dateRange("nextd", "dt").join("~")});break;//三相【周电量(日级)】历史曲线
    case "Tri_[E_(M_d)]_HisCurve": opt = TriEnergyList({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.E,
      TimeScale:TimeScale.Day,DateRange: DF.accCorrect(DF.dateRange("M"), "d", "dt").join("~")});break;//三相【月电量(日级)】历史曲线
    case "Tri_[E_(y_w)]_HisCurve": opt = TriEnergyList({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.E,
      TimeScale:TimeScale.Month,DateRange: DF.dateRange("nextM", "dt").join("~")});break;//三相【年电量(周级)】历史曲线
    case "Tri_[E_(y_M)]_HisCurve": opt = TriEnergyList({id:phrase,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.E,
      TimeScale:TimeScale.Year,DateRange: DF.dateRange("nexty", "dt").join("~")});break;//三相【年电量(月级)】历史曲线

    case "Tri_[P]_ForeValue":break;//三相【有功功率】预测值
    case "Tri_[U]_ForeValue":break;//三相【电压】预测值
    case "Tri_[I]_ForeValue":break;//三相【电流】预测值
    case "Tri_[nodeState]_ForeValue":break;//三相【(P/U/I)】预测值
    case "Tri_[Q]_ForeValue":break;//三相【无功功率】预测值
    case "Tri_[PF]_ForeValue":break;//三相【功率因素】预测值
    case "Tri_[F]_ForeValue":break;//三相【频率】预测值
    case "Tri_[E_(H_)]_ForeValue":break;//三相【时电量】预测值
    case "Tri_[E_(d_)]_ForeValue":break;//三相【日电量】预测值
    case "Tri_[E_(w_)]_ForeValue":break;//三相【周电量】预测值
    case "Tri_[E_(M_)]_ForeValue":break;//三相【月电量】预测值
    case "Tri_[E_(y_)]_ForeValue":break;//三相【年电量】预测值

    case "Tri_[P_(h_s)]_ForeCurve":break;//三相【时内_有功功率】预测曲线
    case "Tri_[U_(h_s)]_ForeCurve":break;//三相【时内_电压】预测曲线
    case "Tri_[I_(h_s)]_ForeCurve":break;//三相【时内_电流】预测曲线
    case "Tri_[Q_(h_s)]_ForeCurve":break;//三相【时内_无功功率】预测曲线
    case "Tri_[PF_(h_s)]_ForeCurve":break;//三相【时内_功率因素】预测曲线
    case "Tri_[F_(h_s)]_ForeCurve":break;//三相【时内_频率】预测曲线
    case "Tri_[P_(d_s)]_ForeCurve":break;//三相【日内_有功功率】预测曲线
    case "Tri_[U_(d_s)]_ForeCurve":break;//三相【日内_电压】预测曲线
    case "Tri_[I_(d_s)]_ForeCurve":break;//三相【日内_电流】预测曲线
    case "Tri_[Q_(d_s)]_ForeCurve":break;//三相【日内_无功功率】预测曲线
    case "Tri_[PF_(d_s)]_ForeCurve":break;//三相【日内_功率因素】预测曲线
    case "Tri_[F_(d_s)]_ForeCurve":break;//三相【日内_频率】预测曲线
    case "Tri_[E_(d_H)]_ForeCurve":break;//三相【日电量(小时级)】预测曲线
    case "Tri_[E_(w_d)]_ForeCurve":break;//三相【周电量(日级)】预测曲线
    case "Tri_[E_(M_d)]_ForeCurve":break;//三相【月电量(日级)】预测曲线
    case "Tri_[E_(y_w)]_ForeCurve":break;//三相【年电量(周级)】预测曲线
    case "Tri_[E_(y_M)]_ForeCurve":break;//三相【年电量(月级)】预测曲线

  }
  return opt;
}

export const QuickStart3 = (phrase,obj) => {
  let opt = undefined;
  switch (phrase){
    case "Sgl_[P]_Value": opt = [CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId})]; break;//单相【有功功率】状态值
    case "Sgl_[U]_Value": opt = [CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U})]; break;//单相【电压】状态值
    case "Sgl_[I]_Value": opt = [CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I})];break;//单相【电流】状态值
    case "Sgl_[nodeState]_Value": opt = [
      CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId}),
      CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U}),
      CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I})
    ];break;//单相【(P/U/I)】状态值
    case "Sgl_[Q]_Value": break;//单相【无功功率】状态值
    case "Sgl_[PF]_Value": opt = [CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.Factor})]; break;//单相【功率因素】状态值
    case "Sgl_[F]_Value": break;//单相【频率】状态值
    case "Sgl_[E_(H_)]_Value": opt = [EnergyV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Hour,DateRange: DF.dateRange("H", "dt").join("~")})];break; //单相【时电量】状态值
    case "Sgl_[E_(d_)]_Value": opt = [EnergyV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Day,DateRange: DF.dateRange("nextd", "dt").join("~")})];break;//单相【日电量】状态值
    case "Sgl_[E_(w_)]_Value": opt = [EnergyV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Week,DateRange: DF.dateRange("nextw", "dt").join("~")})];break;//单相【周电量】状态值
    case "Sgl_[E_(M_)]_Value": opt = [EnergyV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Month,DateRange: DF.dateRange("nextM", "dt").join("~")})];break;//单相【月电量】状态值
    case "Sgl_[E_(y_)]_Value": opt = [EnergyV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Year,DateRange: DF.dateRange("nexty", "dt").join("~")})];break;//单相【年电量】状态值
    case "Sgl_[Ctrl]_Value": opt = [CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.Control,Rtype:Rtype.ToJson})];break;
    case "Sgl_[Conn]_Value": opt = [CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.Conn,Rtype:Rtype.ToJson})];break;
    case "Sgl_[Switch]_Value": opt = [CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.SwitchState})];break;
    case "Sgl_[Temperature]_Value": opt = [CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.T})];break; //温度
    case "Sgl_[Humi]_Value": opt = [CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.HUMI})];break; //湿度
    case "Sgl_[Illum]_Value": opt = [CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.ILLUM})];break; //光照强度
    case "Sgl_[Environment]_Value": opt = [
      CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.T}),
      CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.HUMI}),
      CurveV({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.ILLUM})
    ];break; //环境参数

    case "Sgl_[P_(h_s)]_HisCurve": opt = [CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      DateRange: DF.dateRange("H", "dt").join("~")})];break;//单相【时内_有功功率】历史曲线
    case "Sgl_[U_(h_s)]_HisCurve": opt = [CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      Vtype:Vtype.U,DateRange: DF.dateRange("H", "dt").join("~")})];break;//单相【时内_电压】历史曲线
    case "Sgl_[I_(h_s)]_HisCurve": opt = [CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      Vtype:Vtype.I,DateRange: DF.dateRange("H", "dt").join("~")})];break;//单相【时内_电流】历史曲线
    case "Sgl_[Q_(h_s)]_HisCurve": break;//单相【时内_无功功率】历史曲线
    case "Sgl_[PF_(h_s)]_HisCurve": break;//单相【时内_功率因素】历史曲线
    case "Sgl_[F_(h_s)]_HisCurve": break;//单相【时内_频率】历史曲线
    case "Sgl_[P_(d_s)]_HisCurve": opt = [CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId})];break;//单相【日内_有功功率】历史曲线
    case "Sgl_[U_(d_s)]_HisCurve": opt = [CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U})];break;//单相【日内_电压】历史曲线
    case "Sgl_[I_(d_s)]_HisCurve": opt = [CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I})];break;//单相【日内_电流】历史曲线
    case "Sgl_[Q_(d_s)]_HisCurve": break; //单相【日内_无功功率】历史曲线
    case "Sgl_[PF_(d_s)]_HisCurve": break; //单相【时内_有功功率】历史曲线
    case "Sgl_[F_(d_s)]_HisCurve": break; //单相【日内_频率】历史曲线
    case "Sgl_[E_(d_H)]_HisCurve": opt = [EnergyList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Hour,DateRange: DF.accCorrect(DF.dateRange("d"), "H", "dt").join("~")})];break;//单相【日电量(小时级)】历史曲线
    case "Sgl_[E_(w_d)]_HisCurve": opt = [EnergyList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Day,DateRange: DF.accCorrect(DF.dateRange("w"), "d", "dt").join("~")})];break;//单相【周电量(日级)】历史曲线
    case "Sgl_[E_(M_d)]_HisCurve": opt = [EnergyList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Day,DateRange: DF.accCorrect(DF.dateRange("M"), "d", "dt").join("~")})];break;//单相【月电量(日级)】历史曲线
    case "Sgl_[E_(y_w)]_HisCurve": opt = [EnergyList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Week,DateRange: DF.accCorrect(DF.dateRange("y"), "W", "dt").join("~")})];break;//单相【年电量(周级)】历史曲线
    case "Sgl_[E_(y_M)]_HisCurve": opt = [EnergyList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,
      TimeScale:TimeScale.Month,DateRange: DF.accCorrect(DF.dateRange("y"), "M", "dt").join("~")})];break;//单相【年电量(月级)】历史曲线
    case "Sgl_[Ctrl]_HisCurve": opt = [CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.Control,Rtype:Rtype.ToAssignList})];break;
    case "Sgl_[Conn]_HisCurve": opt = [CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.Conn,Rtype:Rtype.ToAssignList})];break;
    case "Sgl_[Switch]_HisCurve": opt = [CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.SwitchState})];break;
    case "Sgl_[Temperature]_HisCurve": opt = [CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.T})];break;
    case "Sgl_[Humi]_HisCurve": opt = [CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.HUMI})];break;
    case "Sgl_[Illum]_HisCurve": opt = [CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.ILLUM})];break;
    case "Sgl_[Environment]_HisCurve": opt = [
      CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.T}),
      CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.HUMI}),
      CurveList({id:phrase + obj.code,Utype:obj.uType,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.ILLUM})
    ];break;

    case "Sgl_[P]_ForeValue":break;//单相【有功功率】预测值
    case "Sgl_[U]_ForeValue":break;//单相【电压】预测值
    case "Sgl_[I]_ForeValue":break;//单相【电流】预测值
    case "Sgl_[nodeState]_ForeValue":break;//单相【(P/U/I)】预测值
    case "Sgl_[Q]_ForeValue":break;//单相【无功功率】预测值
    case "Sgl_[PF]_ForeValue":break;//单相【功率因素】预测值
    case "Sgl_[F]_ForeValue":break;//单相【频率】预测值
    case "Sgl_[E_(H_)]_ForeValue":break;//单相【时电量】预测值
    case "Sgl_[E_(d_)]_ForeValue":break;//单相【日电量】预测值
    case "Sgl_[E_(w_)]_ForeValue":break;//单相【周电量】预测值
    case "Sgl_[E_(M_)]_ForeValue":break;//单相【月电量】预测值
    case "Sgl_[E_(y_)]_ForeValue":break;//单相【年电量】预测值

    case "Sgl_[P_(h_s)]_ForeCurve":break;//单相【时内_有功功率】预测曲线
    case "Sgl_[U_(h_s)]_ForeCurve":break;//单相【时内_电压】预测曲线
    case "Sgl_[I_(h_s)]_ForeCurve":break;//单相【时内_电流】预测曲线
    case "Sgl_[Q_(h_s)]_ForeCurve":break;//单相【时内_无功功率】预测曲线
    case "Sgl_[PF_(h_s)]_ForeCurve":break;//单相【时内_功率因素】预测曲线
    case "Sgl_[F_(h_s)]_ForeCurve":break;//单相【时内_频率】预测曲线
    case "Sgl_[P_(d_s)]_ForeCurve":break;//单相【日内_有功功率】预测曲线
    case "Sgl_[U_(d_s)]_ForeCurve":break;//单相【日内_电压】预测曲线
    case "Sgl_[I_(d_s)]_ForeCurve":break;//单相【日内_电流】预测曲线
    case "Sgl_[Q_(d_s)]_ForeCurve":break;//单相【日内_无功功率】预测曲线
    case "Sgl_[PF_(d_s)]_ForeCurve":break;//单相【日内_功率因素】预测曲线
    case "Sgl_[F_(d_s)]_ForeCurve":break;//单相【日内_频率】预测曲线
    case "Sgl_[E_(d_H)]_ForeCurve":break;//单相【日电量(小时级)】预测曲线
    case "Sgl_[E_(w_d)]_ForeCurve":break;//单相【周电量(日级)】预测曲线
    case "Sgl_[E_(M_d)]_ForeCurve":break;//单相【月电量(日级)】预测曲线
    case "Sgl_[E_(y_w)]_ForeCurve":break;//单相【年电量(周级)】预测曲线
    case "Sgl_[E_(y_M)]_ForeCurve":break;//单相【年电量(月级)】预测曲线

    case "Tri_[P]_Value": opt = [TriPhaseV({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.P})];break;//三相【有功功率】状态值
    case "Tri_[U]_Value": opt = [TriPhaseV({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U})];break;//三相【电压】状态值
    case "Tri_[I]_Value": opt = [TriPhaseV({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I})];break;//三相【电流】状态值
    case "Tri_[nodeState]_Value": opt = [
      TriPhaseV({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.P}),
      TriPhaseV({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U}),
      TriPhaseV({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I})
    ];break;//三相【(P/U/I)】状态值
    case "Tri_[Q]_Value":break;//三相【无功功率】状态值
    case "Tri_[PF]_Value": opt = [TriPhaseV({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.PF})];break;//三相【功率因素】状态值
    case "Tri_[F]_Value":break;//三相【频率】状态值
    case "Tri_[E_(H_)]_Value":break;//三相【时电量】状态值
    case "Tri_[E_(d_)]_Value":break;//三相【日电量】状态值
    case "Tri_[E_(w_)]_Value":break;//三相【周电量】状态值
    case "Tri_[E_(M_)]_Value":break;//三相【月电量】状态值
    case "Tri_[E_(y_)]_Value":break;//三相【年电量】状态值

    case "Tri_[P_(h_s)]_HisCurve": opt = [TriCurveList({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.P,
      DateRange:DF.dateRange("H", "dt").join("~")})];break;//三相【时内_有功功率】历史曲线
    case "Tri_[U_(h_s)]_HisCurve": opt = [TriCurveList({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U,
      DateRange:DF.dateRange("H", "dt").join("~")})];break;//三相【时内_电压】历史曲线
    case "Tri_[I_(h_s)]_HisCurve": opt = [TriCurveList({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I,
      DateRange:DF.dateRange("H", "dt").join("~")})];break;//三相【时内_电流】历史曲线
    case "Tri_[Q_(h_s)]_HisCurve":break;//三相【时内_无功功率】历史曲线
    case "Tri_[PF_(h_s)]_HisCurve":break;//三相【时内_功率因素】历史曲线
    case "Tri_[F_(h_s)]_HisCurve":break;//三相【时内_频率】历史曲线
    case "Tri_[P_(d_s)]_HisCurve": opt = [TriCurveList({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.P})];break;//三相【日内_有功功率】历史曲线
    case "Tri_[U_(d_s)]_HisCurve": opt = [TriCurveList({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.U})];break;//三相【日内_电压】历史曲线
    case "Tri_[I_(d_s)]_HisCurve": opt = [TriCurveList({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.I})];break;//三相【日内_电流】历史曲线
    case "Tri_[Q_(d_s)]_HisCurve":break;//三相【日内_无功功率】历史曲线
    case "Tri_[PF_(d_s)]_HisCurve":break;//三相【时内_有功功率】历史曲线
    case "Tri_[F_(d_s)]_HisCurve":break;//三相【日内_频率】历史曲线
    case "Tri_[E_(d_H)]_HisCurve": opt = [TriEnergyList({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.E,
      TimeScale:TimeScale.Hour,DateRange: DF.accCorrect(DF.dateRange("d"), "H", "dt").join("~")})]; break;//三相【日电量(小时级)】历史曲线
    case "Tri_[E_(w_d)]_HisCurve": opt = [TriEnergyList({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.E,
      TimeScale:TimeScale.Day,DateRange: DF.dateRange("nextd", "dt").join("~")})];break;//三相【周电量(日级)】历史曲线
    case "Tri_[E_(M_d)]_HisCurve": opt = [TriEnergyList({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.E,
      TimeScale:TimeScale.Day,DateRange: DF.accCorrect(DF.dateRange("M"), "d", "dt").join("~")})];break;//三相【月电量(日级)】历史曲线
    case "Tri_[E_(y_w)]_HisCurve": opt = [TriEnergyList({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.E,
      TimeScale:TimeScale.Month,DateRange: DF.dateRange("nextM", "dt").join("~")})];break;//三相【年电量(周级)】历史曲线
    case "Tri_[E_(y_M)]_HisCurve": opt = [TriEnergyList({id:phrase + obj.code,Utype:Utype.TriUnit,beeId:obj.beeId,roomId:obj.roomId,deviceId:obj.deviceId,Vtype:Vtype.E,
      TimeScale:TimeScale.Year,DateRange: DF.dateRange("nexty", "dt").join("~")})];break;//三相【年电量(月级)】历史曲线

    case "Tri_[P]_ForeValue":break;//三相【有功功率】预测值
    case "Tri_[U]_ForeValue":break;//三相【电压】预测值
    case "Tri_[I]_ForeValue":break;//三相【电流】预测值
    case "Tri_[nodeState]_ForeValue":break;//三相【(P/U/I)】预测值
    case "Tri_[Q]_ForeValue":break;//三相【无功功率】预测值
    case "Tri_[PF]_ForeValue":break;//三相【功率因素】预测值
    case "Tri_[F]_ForeValue":break;//三相【频率】预测值
    case "Tri_[E_(H_)]_ForeValue":break;//三相【时电量】预测值
    case "Tri_[E_(d_)]_ForeValue":break;//三相【日电量】预测值
    case "Tri_[E_(w_)]_ForeValue":break;//三相【周电量】预测值
    case "Tri_[E_(M_)]_ForeValue":break;//三相【月电量】预测值
    case "Tri_[E_(y_)]_ForeValue":break;//三相【年电量】预测值

    case "Tri_[P_(h_s)]_ForeCurve":break;//三相【时内_有功功率】预测曲线
    case "Tri_[U_(h_s)]_ForeCurve":break;//三相【时内_电压】预测曲线
    case "Tri_[I_(h_s)]_ForeCurve":break;//三相【时内_电流】预测曲线
    case "Tri_[Q_(h_s)]_ForeCurve":break;//三相【时内_无功功率】预测曲线
    case "Tri_[PF_(h_s)]_ForeCurve":break;//三相【时内_功率因素】预测曲线
    case "Tri_[F_(h_s)]_ForeCurve":break;//三相【时内_频率】预测曲线
    case "Tri_[P_(d_s)]_ForeCurve":break;//三相【日内_有功功率】预测曲线
    case "Tri_[U_(d_s)]_ForeCurve":break;//三相【日内_电压】预测曲线
    case "Tri_[I_(d_s)]_ForeCurve":break;//三相【日内_电流】预测曲线
    case "Tri_[Q_(d_s)]_ForeCurve":break;//三相【日内_无功功率】预测曲线
    case "Tri_[PF_(d_s)]_ForeCurve":break;//三相【日内_功率因素】预测曲线
    case "Tri_[F_(d_s)]_ForeCurve":break;//三相【日内_频率】预测曲线
    case "Tri_[E_(d_H)]_ForeCurve":break;//三相【日电量(小时级)】预测曲线
    case "Tri_[E_(w_d)]_ForeCurve":break;//三相【周电量(日级)】预测曲线
    case "Tri_[E_(M_d)]_ForeCurve":break;//三相【月电量(日级)】预测曲线
    case "Tri_[E_(y_w)]_ForeCurve":break;//三相【年电量(周级)】预测曲线
    case "Tri_[E_(y_M)]_ForeCurve":break;//三相【年电量(月级)】预测曲线

  }
  return opt;
}

export const StateV = (params) =>{
  return Object.assign({
    id: 'StateV',
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.STATE,
    Utype: "",
    Vtype: Vtype.P
  },params)
}

export const CurveV = (params) => {
  return Object.assign({
    id: 'CurveV',
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: "",
    Vtype: Vtype.P,
    Rtype: Rtype.ToValue,
    DateRange: "#1"
  },params)
}

export const CurveList = (params) => {
  return Object.assign({
    id: 'CurveList',
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: Utype.TERMINAL,
    Vtype: Vtype.P,
    Rtype: Rtype.ToList,
    DateRange: DF.dateRange("d", "dt").join("~")
  },params)
}

export const EnergyV = (params) => {
  return Object.assign({
    id: "EnergyV",
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: Utype.GATEWAY,
    Vtype: Vtype.E,
    TimeScale: TimeScale.Day,
    DateRange: DF.dateRange("nextd", "dt").join("~"),
    Rtype: Rtype.ToValue
  },params)
}

export const EnergyList = (params) => {
  return Object.assign({
    id: 'EnergyList',
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: Utype.TERMINAL,
    Vtype: Vtype.E,
    Rtype: Rtype.ToList,
    TimeScale:TimeScale.Hour,
    DateRange: DF.accCorrect(DF.dateRange("d"), "H", "dt").join("~")
  },params)
}

export const TriPhaseV = (params) => {
  return Object.assign({
    id: 'TriPhaseV',
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: Utype.TriUnit,
    Vtype: Vtype.P,
    Rtype: Rtype.ToValue,
    DateRange: "#1"
  },params)
}

export const TriCurveList = (params) => {
  return Object.assign({
    id: 'TriCurveList',
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: Utype.TriUnit,
    Vtype: "",
    Rtype: Rtype.ToList,
    DateRange: DF.dateRange("d", "dt").join("~")
  },params)
}

export const TriEneryV = (params) => {
  return Object.assign({
    id: "TriEnergyV",
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: Utype.GATEWAY,
    Vtype: Vtype.E,
    TimeScale: TimeScale.Day,
    DateRange: DF.dateRange("nextd", "dt").join("~"),
    Rtype: Rtype.ToValue
  },params)
}

export const TriEnergyList = (params) => {
  return Object.assign({
    id: 'TriEnergyList',
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: Utype.TriUnit,
    Vtype: Vtype.E,
    Rtype: Rtype.ToList,
    DateRange: DF.dateRange("d", "dt").join("~")
  },params)
}

const QP = {
  RealPList: {
    id: 1,
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: Utype.GATEWAY,
    Vtype: Vtype.P,
    Rtype: Rtype.ToList,
    DateRange: DF.dateRange("d", "dt").join("~")
  },
  StateP: {
    id: 2,
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.STATE,
    Utype: "",
    Vtype: Vtype.P
  },
  DayE: {
    id: 100,
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: Utype.GATEWAY,
    Vtype: Vtype.E,
    TimeScale: TimeScale.Day,
    DateRange: DF.dateRange("nextd", "dt").join("~"),
    Rtype: Rtype.ToValue
  },
  WeekE: {
    id: 101,
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: Utype.GATEWAY,
    Vtype: Vtype.E,
    TimeScale: TimeScale.Week,
    DateRange: DF.dateRange("nextw", "dt").join("~"),
    Rtype: Rtype.ToValue
  },
  MonthE: {
    id: 102,
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: Utype.GATEWAY,
    Vtype: Vtype.E,
    TimeScale: TimeScale.Month,
    DateRange: DF.dateRange("nextM", "dt").join("~"),
    Rtype: Rtype.ToValue
  },
  DayHEList: {
    id: 200,
    beeId: "",
    roomId: "",
    deviceId: "",
    QType: QType.CURVE,
    Utype: Utype.GATEWAY,
    Vtype: Vtype.E,
    TimeScale: TimeScale.Hour,
    DateRange: DF.accCorrect(DF.dateRange("d"), "H", "dt").join("~"),
    Rtype: Rtype.ToList
  },
  WeekDEList: {
    id: 201,
    beeId: "",
    QType: QType.CURVE,
    Utype: Utype.GATEWAY,
    Vtype: Vtype.E,
    TimeScale: TimeScale.Day,
    DateRange: DF.accCorrect(DF.dateRange("w"), "d", "dt").join("~"),
    Rtype: Rtype.ToList
  },
  MonthDEList: {
    id: 202,
    beeId: "",
    QType: QType.CURVE,
    Utype: Utype.GATEWAY,
    Vtype: Vtype.E,
    TimeScale: TimeScale.Day,
    DateRange: DF.accCorrect(DF.dateRange("M"), "d", "dt").join("~"),
    Rtype: Rtype.ToList
  },
  YearMEList: {
    id: 203,
    beeId: "",
    QType: QType.CURVE,
    Utype: Utype.GATEWAY,
    Vtype: Vtype.E,
    TimeScale: TimeScale.Month,
    DateRange: DF.accCorrect(DF.dateRange("y"), "M", "dt").join("~"),
    Rtype: Rtype.ToList
  },
  switchState:{
    id: 300,
    beeId:"",
    QType:QType.SWITCH,
    Utype:""
  }
}

export const QueryProp = (beeId, DKey, prop) => {
  let newQP = JSON.parse(JSON.stringify(QP));
  Object.keys(newQP).forEach(item => newQP[item].beeId = beeId)
  return Object.assign(newQP[DKey], prop)
}
